<template>
    <div>
        <b-card>
          <h3>Tanks / Boilers</h3>
          <br/>
          <b-row>
            <b-col>These questions can be defaulted if no configuration required</b-col>
            <b-col><b-button variant="outline-info" v-on:click="SkipPage()">Use Default Values</b-button></b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col cols="1">Q1</b-col>
            <b-col align="left">Cold Storage Max Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.Tanks.ColdWaterMax" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q2</b-col>
            <b-col align="left">Hot Storage Min Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.Tanks.HotWaterMin" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q3</b-col>
            <b-col align="left">Hot Storage Max Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.Tanks.HotWaterMax" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q4</b-col>
            <b-col align="left">Combi Boiler Min Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.Tanks.CombiMin" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q5</b-col>
            <b-col align="left">Point of Use Min Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.Tanks.POUMin" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q6</b-col>
            <b-col align="left">Point of Use Max Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.Tanks.POUMax" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q7</b-col>
            <b-col align="left">Calorifier Out Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.Tanks.CalorifierOut" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q8</b-col>
            <b-col align="left">Calorifier Return Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.Tanks.CalorifierReturn" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <hr/>
          <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Page Complete</b-button></b-col></b-row>
        </b-card>
    </div>
</template>

<script>
    export default {
      props:['DataPass','Type','ID'],
      data() {
      return {
        stepComplete: false,
        InvalidNum: false,
        Values:{
          Tanks: {
                ColdWaterMax: "",
                HotWaterMin: "",
                HotWaterMax: "",
                CombiMin: "",
                POUMin: "",
                POUMax: "",
                CalorifierOut: "",
                CalorifierReturn: ""
                    },
                  }
      }
    },
    computed: {},
    components: {},
    mounted(){
      if (this.Type == 'Modify'){
        this.Values.Tanks.ColdWaterMax = this.DataPass.Tanks.ColdWaterMax
        this.Values.Tanks.HotWaterMin = this.DataPass.Tanks.HotWaterMin
        this.Values.Tanks.HotWaterMax = this.DataPass.Tanks.HotWaterMax
        this.Values.Tanks.CombiMin = this.DataPass.Tanks.CombiMin
        this.Values.Tanks.POUMin = this.DataPass.Tanks.POUMin
        this.Values.Tanks.POUMax = this.DataPass.Tanks.POUMax
        this.Values.Tanks.CalorifierOut = this.DataPass.Tanks.CalorifierOut
        this.Values.Tanks.CalorifierReturn = this.DataPass.Tanks.CalorifierReturn
      }else{

        this.Values.Tanks.ColdWaterMax = 16.00
        this.Values.Tanks.HotWaterMin =  60.00
        this.Values.Tanks.HotWaterMax = 65.00
        this.Values.Tanks.CombiMin = 50.00
        this.Values.Tanks.POUMin = 50.00
        this.Values.Tanks.POUMax = 55.00
        this.Values.Tanks.CalorifierOut = 60.00
        this.Values.Tanks.CalorifierReturn = 50.00
      }

       
    },
    methods:{
      CompletePage(){
        if (this.NumberCheck(this.Values) == true){
          alert("Please ensure entries contain only valid numbers")
        } else{
        this.$emit("PageComplete",4,this.Values)
        this.stepComplete = true;
        }
      },
      SkipPage(){
        this.Values.Tanks.ColdWaterMax = 16.00
        this.Values.Tanks.HotWaterMin =  60.00
        this.Values.Tanks.HotWaterMax = 65.00
        this.Values.Tanks.CombiMin = 50.00
        this.Values.Tanks.POUMin = 50.00
        this.Values.Tanks.POUMax = 55.00
        this.Values.Tanks.CalorifierOut = 60.00
        this.Values.Tanks.CalorifierReturn = 50.00
        this.$emit("PageComplete",4,this.Values)
        this.stepComplete = true;
        
      },
      NumberCheck(data){
        this.InvalidNum = false
        
        let invalidcoldmax = /^\d{1,3}(\.\d+)?$/.test(data.Tanks.ColdWaterMax)
        let invalidhotmin = /^\d{1,3}(\.\d+)?$/.test(data.Tanks.HotWaterMin)
        let invalidhotmax = /^\d{1,3}(\.\d+)?$/.test(data.Tanks.HotWaterMax)
        let invalidcombimin = /^\d{1,3}(\.\d+)?$/.test(data.Tanks.CombiMin)
        let invalidpoumin = /^\d{1,3}(\.\d+)?$/.test(data.Tanks.POUMin)
        let invalidpoumax = /^\d{1,3}(\.\d+)?$/.test(data.Tanks.POUMax)
        let invalidcalorout = /^\d{1,3}(\.\d+)?$/.test(data.Tanks.CalorifierOut)
        let invalidcalorret = /^\d{1,3}(\.\d+)?$/.test(data.Tanks.CalorifierReturn)
        
        if (!invalidcoldmax || !invalidhotmin || !invalidhotmax || !invalidcombimin || !invalidpoumin || !invalidpoumax || !invalidcalorout || !invalidcalorret){
          this.InvalidNum = true
        }

        return this.InvalidNum
      }
    },

    }
</script>

<style>

</style>